import React, { useMemo } from 'react';
import { BrandLogo as CommonBrandLogo } from '@common/components/brand-logo';
import { ISpace } from '../../types';
import './style.scss';

interface IBrandLogo {
  space?: ISpace | null;
}
const BrandLogo = (props: IBrandLogo) => {
  const { space } = props;

  const spaceLogo = useMemo(() => {
    if (!space || !space.logo_path) return undefined;
    return space.logoUrl;
  }, [space]);

  const spaceName = useMemo(() => {
    if (!space || !space.name) return undefined;
    return space.name;
  }, [space]);

  return (
    <div className="brand-logo">
      <CommonBrandLogo src={spaceLogo} alt={spaceName} />
    </div>
  );
};

export default BrandLogo;